import React from 'react';
import { Code, Menu, Smartphone, Calendar, MapPin, TrendingUp } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

const iconMap = {
  0: Code,
  1: Menu,
  2: Smartphone,
  3: Calendar,
  4: MapPin,
  5: TrendingUp
};

const Services = ({ t }) => {
  return (
    <section id="services" className="py-24 bg-slate-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t.services.title}
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">
            {t.services.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {t.services.items.map((service, index) => {
            const Icon = iconMap[index];
            return (
              <Card
                key={index}
                className="bg-slate-800/50 border-slate-700 hover:bg-slate-800 transition-all duration-300 hover:scale-105 hover:shadow-xl"
              >
                <CardHeader>
                  <div className="w-12 h-12 bg-white/10 rounded-lg flex items-center justify-center mb-4">
                    <Icon className="h-6 w-6 text-white" />
                  </div>
                  <CardTitle className="text-white text-xl">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-slate-400 text-base leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="text-center">
          <div className="inline-block bg-slate-800 border border-slate-700 rounded-lg px-8 py-4">
            <p className="text-white font-medium text-lg">
              Custom requests welcome – tell me what you need!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
